export const SharePoint = {
  "NewVersionAvailable": "New Version Available",
  "GetLatestVersion": "Get Latest Version",
  "Warning": {
    "HasNewUpdate": "The file has been modified and some changes failed to save, please click below to get the latest version."
  }
}